module.exports = __webpack_public_path__ + "static/media/Banner_7.e0c43615.jpg";